import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import style from './scale-dropdown-items.module.css';
import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

const workstationOfflineStatus = () => {
  return (
    <div className={style['workstation-offline']}>
      <FormattedMessage defaultMessage='(Offline)' description='formPreferences.offline' id='Kf3MNu' />
    </div>
  );
};

const renderNoScalesAvailable = () => {
  return (
    <DropdownMenuItem key='noScale' disabled>
      <div>
        <FormattedMessage defaultMessage='No Scales Available' description='formPreferences.noScales' id='/uSOUJ' />
      </div>
    </DropdownMenuItem>
  );
};

const renderScales = (scales, onSelectScale) => {
  return scales.map((scale) => (
    <DropdownMenuItem key={scale.id} onClick={() => onSelectScale(scale)}>
      <div className={style['scale-selection']}>{scale.name}</div>
    </DropdownMenuItem>
  ));
};

export const ScaleDropdownItems = ({ scalesGroupedByWorkstation = emptyArray, onSelectScale = noop }) => {
  return scalesGroupedByWorkstation.map((scaleGroup) => [
    <div key={scaleGroup.workstationName} className={style['workstation-dropdownitem']} disabled>
      <div>
        {scaleGroup.workstationName}
        {!scaleGroup.workstationIsOnline && workstationOfflineStatus()}
      </div>
    </div>,
    scaleGroup.scales.length === 0 ? renderNoScalesAvailable() : renderScales(scaleGroup.scales, onSelectScale),
  ]);
};

ScaleDropdownItems.propTypes = {
  scalesGroupedByWorkstation: PropTypes.arrayOf(
    PropTypes.shape({
      workstationName: PropTypes.string,
      workstationIsOnline: PropTypes.bool,
      scales: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
  ),
  onSelectScale: PropTypes.func,
};
